import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
export const UiIconTwitter = (props) => (_jsx(SvgIcon, Object.assign({}, props, { children: _jsx("path", { d: "M17.8,2h3.1l-6.7,8.5L22,22h-6.2L11,15l-5.5,7H2.4l7.2-9.1L2,2h6.3l4.4,6.4L17.8,2z M16.7,20h1.7l-11-16H5.6\n\tL16.7,20z" }) })));
//# sourceMappingURL=ui_icon_twitter.js.map